//输入控件
import React, { Component } from 'react';
import { Modal, List, Button, WhiteSpace, WingBlank, Icon } from 'antd-mobile';
import tools from '../utils/tools';
import './Dropdown.less';
import { tools as vTools} from 'tplus-voucher';

class Dropdown extends Component {

  //构造函数
  constructor(props, context) {
    //写构造方法时  必须实现父类的构造方法  否则构造失败  报错
    super(props, context);
    this.state = { show: false }
  }
  /*================自定义事件====================*/

  renderContent() {
    const { IsFreeItem, dataSource, value } = this.props;
    if (!dataSource) {
      return null;
    }
    this.selectValue = IsFreeItem ? value : value ? value.ID : -1;
    return dataSource.map(item => {
      let className = item.ID == this.selectValue ? 'dropdownItemSelect' : 'dropdownItem';
      return (
        <div onClick={this.itemClick} data-value={item.ID} className={className}>{item.Name}</div>
      );
    });
  }

  itemClick = (e) => {
    tools.preventEvent(e);
    const { dataSource } = this.props;

    const selectValue = e.target.attributes['data-value'].value
    dataSource.forEach(item => {
      if (item.ID == selectValue) {
        const { onChange } = this.props;
        if (onChange)
          onChange(item);
      }
    })
    this.onClose();
  }

  render() {
    const { Title, value, showClearBtn } = this.props;
    const displayValue = value && value.Name ? value.Name : '';
    const className = this.state.show ? 'icon-shouqitubiao1' : 'icon-zhankaitubiao1';
    const fonts = vTools.getLocalCache('fonts');
    const mainClass = fonts && fonts.ID == '1' ? 'dropdown-X' : 'dropdown';
    const dropdownContentClass = fonts && fonts.ID == '1' ? 'dropdownContent-X' : 'dropdownContent';
    return (<div className={mainClass} onClick={this.onShow}><span className='title'>{displayValue}</span>
      <Modal
        popup
        visible={this.state.show}
        animationType="slide-up">
        <div className={dropdownContentClass}>
            {this.renderContent()}
        </div>
        <div className='btnArea'>
            {this.selectValue && showClearBtn && <div className='clearBtn' onClick={this.clear}>清空</div>}
            <div className={`${!showClearBtn ? 'newCancelBtn': 'cancelBtn'}`} type="primary" onClick={this.cancel}>取消</div>
          </div>
      </Modal><span className={`icon iconfont ${className} dropBtn`} /></div>);
  }

  cancel = (e) => {
    tools.preventEvent(e);
    this.onClose();
  }


  clear = (e) => {
    tools.preventEvent(e);
    const { onChange } = this.props;
    if (onChange) {
      onChange({ ID: null, Code: null, Name: null });
    }
    this.onClose();
  }

  onClose = () => {
    this.setState({
      show: false
    });
  }

  onShow = () => {
    if(this.props.templateItem && this.props.templateItem.ReadOnly == true){
      return;
    }
    this.setState({
      show: true
    });
  }

}
export default Dropdown;
